import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IntegrationSourceExtractorService {
  extractValue(sourceId: string | null | undefined, payload: unknown): unknown {
    if (!sourceId || typeof sourceId !== 'string') {
      return undefined;
    }

    const trimmed = sourceId.trim();
    if (!trimmed) {
      return undefined;
    }

    const segments = trimmed.split(':').map((part) => part.trim()).filter((part) => part.length > 0);
    if (segments.length === 0) {
      return undefined;
    }

    let current: unknown = payload;

    for (let i = 0; i < segments.length; i++) {
      const token = segments[i];

      if (i === 0) {
        if (!this.isObjectLike(current)) {
          return undefined;
        }
        current = (current as Record<string, unknown>)[token];
        continue;
      }

      const numericIndex = this.tryParseIndex(token);
      if (numericIndex !== null) {
        if (!Array.isArray(current) || numericIndex < 0 || numericIndex >= current.length) {
          return undefined;
        }
        current = current[numericIndex];
        continue;
      }

      if (!this.isObjectLike(current)) {
        return undefined;
      }
      current = (current as Record<string, unknown>)[token];
    }

    return current;
  }

  private isObjectLike(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null;
  }

  private tryParseIndex(value: string): number | null {
    if (!/^\d+$/.test(value)) {
      return null;
    }

    const parsed = Number(value);
    return Number.isInteger(parsed) ? parsed : null;
  }
}
